import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ListaDias from './ListaDias';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter} from 'react-router-dom';
import {  Routes, Route, Link, useLocation, useNavigate ,HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
